import { useEffect, useState } from 'react'

interface ElectronAPI {
  getVersion: () => string
  getPlatform: () => string
  isElectron: () => boolean
}

declare global {
  interface Window {
    electronAPI?: ElectronAPI
  }
}

export const useElectron = () => {
  const [isElectron, setIsElectron] = useState(false)
  const [platform, setPlatform] = useState<string>('')
  const [version, setVersion] = useState<string>('')

  useEffect(() => {
    // Check if we're running in Electron
    const checkElectron = () => {
      if (window.electronAPI?.isElectron) {
        setIsElectron(true)
        setPlatform(window.electronAPI.getPlatform())
        setVersion(window.electronAPI.getVersion())

        // Add electron class to body for CSS targeting
        document.body.classList.add('electron-app')
        document.body.classList.add(window.electronAPI.getPlatform())
      } else {
        setIsElectron(false)
        // Remove electron classes if not in Electron
        document.body.classList.remove('electron-app', 'darwin', 'win32', 'linux')
      }
    }

    // Check immediately
    checkElectron()

    // Also check after a short delay in case electronAPI loads asynchronously
    const timeout = setTimeout(checkElectron, 100)

    return () => clearTimeout(timeout)
  }, [])

  return {
    isElectron,
    platform,
    version,
    isDarwin: platform === 'darwin',
    isWindows: platform === 'win32',
    isLinux: platform === 'linux',
  }
}
